import '@/assets/css/payment-function.scss';
import companyInfo from '@/constant/companyInfo';
import { mapState } from "vuex";
export default {

  data() {
    return {
      companyInfo: companyInfo,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
}